export default {"src":"/_next/static/media/clock-outline-1.bebe4296.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};